import styled from 'styled-components/macro'
import { color, compose, padding, textStyle } from 'styled-system'

export interface NoResultsContainerProps {
  margin?: string
  $inset?: boolean
}

export const NoResultsContainer = styled.div.attrs<NoResultsContainerProps>(
  (props) => ({
    p: 'xl',
    bg: 'bg.neutral',
    margin: props.margin || '16px 24px',
  }),
)<NoResultsContainerProps>`
  ${compose(padding, color)}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.margin || '16px 24px'};
  ${({ $inset }) => $inset && 'border-radius: 12px;'}
`

export const LargeTitle = styled.h2`
  font-weight: normal;
  margin: 24px;
  margin-bottom: 48px;
`

export const SmallTitle = styled.p`
  font-weight: normal;
  font-size: 20px;
  margin: 16px;
  font-weight: 600;
`

export const InsetTitle = styled.p.attrs({ textStyle: 'header.2' })`
  ${textStyle}
  margin: 8px 0 4px;
  font-weight: 400;
`

export const Note = styled.p<{ $inset?: boolean }>`
  font-size: 16px;
  margin-bottom: ${({ $inset }) => ($inset ? 0 : '20px')};
`
